// extracted by mini-css-extract-plugin
export default {"Container":"Styles_Container__GWl7g","rotate":"Styles_rotate__ZVWKL"};